import { ENVS } from '@adsk/acs-sc-web-platform-api';
import { EntitlementsProject } from '@adsk/alloy-provider';
import { NOTIFICATION_STATUSES } from '@adsk/alloy-react-notification';

export const SCROLL_CONTAINER_ID = 'scroll-to-top';
export const NO_PERMISSIONS_HELP_ARTICLE =
  'https://help.autodesk.com/view/DOCS/ENU/?guid=Manage_Account_Members';
export const CONTACT_SUPPORT_LINK =
  'https://beta.downloads.autodesk.com/ACS/Build/GG%20Webform%20HTML%20Full%20Page%20v1.html';

export const ACCOUNT_ADMIN_PRODUCT_NAME = 'Account Admin';
export const INSIGHT_PRODUCT_NAME = 'Executive Insight';

export const AccountAdminProductName = 'Account Administration';
export const InsightProductName = 'Insight';

export enum FEATURE_FLAGS {
  AllowListCapitalPlanning = 'pl_acs-capital-planning-accounts',
  DisableProjectAndTemplateCreation = 'pl_disable_project_and_template_creation',
  ShowAutoSpecsLink = 'pl_show_autospecs_link',
  BackendSearchProjectEntitlements = 'pl_project_entitlements_backend_search',
  ShowFiltersPanel = 'pl_filters_panel',
}

export const MAPBOX_ACCESS_TOKEN =
  'pk.eyJ1IjoiYW50b255bWFjaWVsIiwiYSI6ImNrODR1Y2F6aTAwNDAzZHJxMmR3czRkbmoifQ.dJkHL1pc1aNAtVADQS8_jw';
export const DEFAULT_SEARCH_KEYS: (keyof EntitlementsProject)[] = ['name'];
export const DEFAULT_SORT_FIELD = 'createdAt';
export const DEFAULT_LIMIT = 25;
export const DEFAULT_SEARCH_BAR_DELAY = 200;

export enum TABLE_SORT_DIRECTION {
  ASCENDING = 1,
  DESCENDING = -1,
}

export enum SORT_DIRECTION {
  ASCENDING = 'asc',
  DESCENDING = 'desc',
}

export const SIDE_FILTERS_KEYS = ['account', 'project_type', 'created_on'];

export const AnalyticsEvents = {
  navigateToOtherProduct: 'prodex.project_list_page.navigate.product.click',
  navigateToNoPermissionsHelpArticle:
    'prodex.project_list_page.navigate.no_permissions_help_article',

  //Projects Tab
  viewProjects: 'prodex.project_list_page.projects.view',
  projectsNavigateToProject:
    'prodex.project_list_page.projects.project.navigate',
  createProjectModalOpen:
    'prodex.project_list_page.projects.create_project.open_modal',
  createProjectModalClose:
    'prodex.project_list_page.projects.create_project.cancel',
  createProjectModalSubmit:
    'prodex.project_list_page.projects.create_project.submit',
  projectsTableSortColumn: 'prodex.project_list_page.projects.sort.change',
  projectsSearchBarChange: 'prodex.project_list_page.projects.search.change',
  projectsPaginationChange:
    'prodex.project_list_page.projects.pagination.change',

  // Templates Tab
  viewTemplates: 'prodex.project_list_page.templates.view',
  templatesNavigateToProject:
    'prodex.project_list_page.templates.project.navigate',
  createProjectTemplateModalOpen:
    'prodex.project_list_page.templates.create_template.open_modal',
  createProjectTemplateModalClose:
    'prodex.project_list_page.templates.create_template.cancel',
  createProjectTemplateModalSubmit:
    'prodex.project_list_page.templates.create_template.submit',
  templatesTableSortColumn: 'prodex.project_list_page.templates.sort.change',
  templatesSearchBarChange: 'prodex.project_list_page.templates.search.change',
  templatesPaginationChange:
    'prodex.project_list_page.templates.pagination.change',
};

export const ErrorNotificationBaseProps = {
  status: NOTIFICATION_STATUSES.ERROR,
  autoDismiss: 0,
  showIcon: true,
};

export enum ProjectStatus {
  Active = 'active',
  Pending = 'pending',
  Suspended = 'suspended',
  Archived = 'archived',
}

export const BUILDING_CONNECTED_URLS = {
  [ENVS.QA]: 'https://app-dev.buildingconnected.com/',
  [ENVS.STAGING]: 'https://app-stage.buildingconnected.com/',
  [ENVS.PRODUCTION]: 'https://app.buildingconnected.com/',
};

export const PLANGRID_URLS = {
  [ENVS.QA]: 'https://plangrid-dev.planfront.net/',
  [ENVS.STAGING]: 'https://plangrid-test.planfront.net/',
  [ENVS.PRODUCTION]: 'https://app.plangrid.com/',
};

export const TRADETAPP_URLS = {
  [ENVS.QA]: 'https://tradetapp-app-dev.herokuapp.com/',
  [ENVS.STAGING]: 'https://tradetapp-app-staging.herokuapp.com/',
  [ENVS.PRODUCTION]: 'https://app.tradetapp.com/',
};

export const AUTOSPECS_URLS = {
  [ENVS.QA]: 'https://autospecs-dev.pype.io/?source=acc',
  [ENVS.STAGING]: 'https://autospecs-test.pype.io/?source=acc',
  [ENVS.PRODUCTION]: 'https://autospecs.pype.io/?source=acc',
};
